import { AxiosResponse } from 'axios';

import { $api } from '../axios/axios';

export default class AdministrationService {
  static async syncEventFromHrm(id: string): Promise<AxiosResponse> {
    return $api.post(`/recruiting-tool/api/v1/admin/${id}/sync-event-from-hrm`);
  }
}
